import { useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import LanguageIcon from "@mui/icons-material/Language"
import { LanguageButton as BaseLanguageButton } from "components/Language"

export const LanguageButton = ({ sx = {}, ...rest }) => {
  const theme = useTheme()
  const { baseRoot, languageIcon } =
    theme.components[`LanguageButton`]?.styleOverrides || {}

  return (
    <BaseLanguageButton
      variant="contained"
      sx={deepmerge(baseRoot, sx)}
      endIcon={<LanguageIcon sx={languageIcon} {...rest} />}
    />
  )
}
